module.exports = __webpack_public_path__ + "img/logout.92662220.svg";